export const URL_REGEX = /^(?:https?:\/{2})?(?:localhost|(?:[\w-]+\.)+[a-z]{2,})(?::\d+)?$/i;
export const IP_V4_REGEX = /^(?:https?:\/{2})?((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.){3}(25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(?::\d+)?$/i;
export const IP_V6_REGEX = /^(?:https?:\/{2})?\[[\d.:a-f]+](?::\d+)?$/i;
